<div class="">
  <div class="page-content">
    <div class="row">
      <div class="col-6">
        <h2 class="heading1 d-none d-sm-block">{{this.getFormTitle}}</h2>
        <h2 class="heading1 d-block d-sm-none">{{this.getFormSubTitle}}</h2>
      </div>
      <div class="col-6 text-end">
        <button *ngIf="canAdd" #buttonNewRow mat-raised-button class="primary-btn" (click)="onClickOfGenericNewButton()">
          {{'Language.CreateNewText' | translate }}
        </button>
      </div>
    </div>
    <div class="row mt-4 d-none d-sm-flex">
      <div class="col-md-6">
        <h3 class="heading2">{{this.getFormSubTitle}}</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 tabledesign">
        <app-chip [filterItems]='selectedFilters' (removeFilter)="onRemoveChip($event.index,$event.data)"></app-chip>

        <table mat-table [dataSource]="this.getListViewDataSource">

          <!-- Select Column -->
          <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="text-center">
              <mat-checkbox class="ps-0"></mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let row;let i=index;" class="text-center">
              <mat-checkbox class="ps-0"></mat-checkbox>
            </td>
          </ng-container>

          <!-- Posting Date Column -->
          <ng-container matColumnDef="postingDate">
            <th mat-header-cell *matHeaderCellDef> {{'Language.PostingDateText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [colType]="'DateType'" [shortColumn]="'docDate'"
                  [labelType]="'Language.DocumentDateText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForDate($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('docDate',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.docDate | date : "dd-MM-yyyy"}}
            </td>
          </ng-container>

          <!-- branch Column -->
          <ng-container matColumnDef="branchName">
            <th mat-header-cell *matHeaderCellDef> {{'Language.BranchNameText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'branchName'" [colType]="'alphabets'"
                  [labelType]="'Language.BranchNameText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('branchName',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.branchName}}
            </td>
          </ng-container>

          <!-- Document No. Column -->
          <ng-container matColumnDef="docNum">
            <th mat-header-cell *matHeaderCellDef>
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              {{'Language.DocumentNumberText' | translate }}

              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'docNum'" [colType]="'numerics'"
                  [labelType]="'Language.DocumentNumberText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('docNum',this.active)"></app-filter>
              </mat-menu>

            </th>
            <td mat-cell *matCellDef="let row;let i=index;">
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              <!-- {{i+1}} -->
              <span class="">{{row.docNum}}</span>
            </td>
          </ng-container>

          <!-- Reference No. Column -->
          <!-- <ng-container matColumnDef="referenceNo">
                        <th mat-header-cell *matHeaderCellDef class="text-center">-->
          <!-- <mat-checkbox class="ps-0"></mat-checkbox> 
                          {{'Language.ReferenceNumberText' | translate }}
                        
                          <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                          <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                            <app-filter [shortColumn]="'docNum'" [colType]="'numerics'" 
                            [labelType]="'Language.DocumentNumberText' | translate" [isActive]="this.active"
                              (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                              (sortFilter)="this.onClickOfGenericColumnSort('docNum',this.active)"></app-filter>
                          </mat-menu>
            
                        </th>
                        <td mat-cell *matCellDef="let row;let i=index;" class="text-center">
                           <mat-checkbox class="ps-0"></mat-checkbox> -->
          <!-- {{i+1}} -->
          <!--   <span class="">{{row.docNum}}</span>
                        </td>
                      </ng-container> -->

          <!--  Customer/Vendor Name Column -->
          <ng-container matColumnDef="customerVendorName">
            <th mat-header-cell *matHeaderCellDef> {{'Language.CardNameText' | translate }}
              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'cardName'" [colType]="'alphabets'"
                  [labelType]="'Language.CardNameText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('cardName',this.active)"></app-filter>
              </mat-menu>
            </th>
            <td mat-cell *matCellDef="let row">
              {{row.cardName}}
            </td>
          </ng-container>

          <!--  Payment Means Column -->
          <!-- <ng-container matColumnDef="paymentMeans">
                      <th mat-header-cell *matHeaderCellDef> {{'Language.PaymentMeansText' | translate }} 
                        <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
                        <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                          <app-filter [shortColumn]="'cardName'" [colType]="'alphabets'" 
                          [labelType]="'Language.CardNameText' | translate" [isActive]="this.active"
                            (FilterColumn)="onClickOfGenericFilterButtonForRangeString($event.column, $event.formid, $event.toid,$event.label)"
                            (sortFilter)="this.onClickOfGenericColumnSort('cardName',this.active)"></app-filter>
                        </mat-menu>
                      </th>
                      <td mat-cell *matCellDef="let row">
                        {{row.cardName}}
                      </td>
                    </ng-container> -->

          <!--  Amount Column -->
          <ng-container matColumnDef="amount">
            <th mat-header-cell *matHeaderCellDef>
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              {{'Language.AmountText' | translate }}

              <i-feather class="t-icon" name="more-vertical" [matMenuTriggerFor]="menu1"></i-feather>
              <mat-menu #menu1="matMenu" class="filtertrigger" xPosition="after">
                <app-filter [shortColumn]="'totalAmount'" [colType]="'numerics'"
                  [labelType]="'Language.AmountText' | translate" [isActive]="this.active"
                  (FilterColumn)="onClickOfGenericFilterButtonForRangeNumber($event.column, $event.formid, $event.toid,$event.label)"
                  (sortFilter)="this.onClickOfGenericColumnSort('totalAmount',this.active)"></app-filter>
              </mat-menu>

            </th>
            <td mat-cell *matCellDef="let row;let i=index;">
              <!-- <mat-checkbox class="ps-0"></mat-checkbox> -->
              <!-- {{i+1}} -->
              <span class="">{{row.totalAmount}}</span>
            </td>
          </ng-container>

          <!-- Star Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="text-center">{{'Language.ActionText' | translate }}</th>
            <td mat-cell *matCellDef="let row" class="text-center">
              <i-feather class="t-icon pointer me-3" *ngIf="canEdit" name="edit-2"
                (click)="onClickOfGenericEditButton(row.docEntry)"></i-feather>
              <i-feather class="t-icon pointer me-3" *ngIf="!canEdit && isActiveMenu" name="eye"
                (click)="onClickOfGenericEditButton(row.docEntry)"></i-feather>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="this.displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: this.displayedColumns;"></tr>
        </table>
      </div>
      <mat-paginator #paginator class="mt-3" [length]="this.getRowCount" [pageSize]="this.getPaginatorPageSize"
        [pageSizeOptions]="this.getPaginatorPageSizeOptions" aria-label="Select page"
        (page)="onClickOfGenericPaginator($event)" showFirstLastButtons>
      </mat-paginator>
    </div>

  </div>


</div>